import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || attempts >= 6) { setStatus("error"); return; }
        attempts++; setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <main className="bg-onyx min-h-screen pt-16 flex items-center grain" data-testid="payment-success-page">
      <div className="max-w-lg mx-auto w-full px-5 py-24 text-center">
        {status === "checking" && (<><Loader2 className="text-gold mx-auto mb-6 animate-spin" size={48} /><h1 className="font-serif text-3xl text-bone">Confirming your payment...</h1></>)}
        {status === "paid" && (
          <>
            <CheckCircle2 className="text-gold mx-auto mb-6" size={56} />
            <h1 className="font-serif text-4xl text-bone mb-3">Ase! Payment Received</h1>
            <p className="text-bone/60 mb-8">Thank you for supporting the mission{info?.product_name ? ` — your ${info.product_name} order is confirmed.` : "."}</p>
            <Link to="/store" className="bg-gold text-black px-8 py-3 font-medium hover:bg-gold2 transition-colors">Continue Shopping</Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="text-red-400 mx-auto mb-6" size={56} />
            <h1 className="font-serif text-3xl text-bone mb-3">Payment Not Completed</h1>
            <p className="text-bone/60 mb-8">Your payment could not be confirmed. Please try again.</p>
            <Link to="/store" className="border border-white/20 text-bone px-8 py-3 hover:bg-white/5 transition-colors">Back to Store</Link>
          </>
        )}
      </div>
    </main>
  );
}
